/* tslint:disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum RedirectToRouteType {
    
        AppointmentDetails = 0,
    
        NonAppointmentDetails = 1,
    
        ProvideAvailability = 2,
    
        AppointmentReport = 3,
    
        NonAppointmentReport = 4,
    
        AvailabilityReminder = 5,
    
        FinanceRemittanceAdvice = 6,
    
        ResourcePage = 7,
    
        ProfessionalAccreditationProfile = 8,
    
        KeyDocuments = 9,
    
        PublicInformationProfile = 10,
    
        ProfessionalServicesProfile = 11,
    
        ProfessionalDetailsProfile = 12,
    
        PersonalDetailsProfile = 13,
    
        TravelAttachmentsUpload = 14,
    
}